(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbm-account"] && !Shopify.designMode) return;
  try {
    
  // „Erneut bestellen": Positionen per Ajax-API in den Warenkorb legen,
  // danach zum Warenkorb weiterleiten. URLs (Locale-/Markets-sicher)
  // kommen als data-Attribute vom Section-Root.
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-sbm-reorder]');
    if (!btn || btn.disabled) return;

    let items;
    try {
      items = JSON.parse(btn.dataset.sbmReorder);
    } catch (error) {
      return;
    }
    if (!Array.isArray(items) || items.length === 0) return;

    const root = btn.closest('.sbm-acct');
    const addUrl = (root && root.dataset.cartAddUrl) || '/cart/add.js';
    const cartUrl = (root && root.dataset.cartUrl) || '/cart';

    btn.disabled = true;
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    })
      .then((response) => {
        if (!response.ok) throw new Error('reorder failed: ' + response.status);
        window.location.href = cartUrl;
      })
      .catch(() => {
        btn.disabled = false;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbm-carousel-content"] && !Shopify.designMode) return;
  try {
    
  // Blaetterlogik wie in sbm-hero-carousel, als eigenes Custom Element.
  class SbmContentCarousel extends HTMLElement {
    connectedCallback() {
      this.slidesEls = Array.from(this.querySelectorAll('[data-sbm-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-sbm-dot]'));
      this.index = 0;

      this.go(0);
      this.classList.add('sbm-content-carousel--bereit');

      // Der Punkt traegt den Namen seines Slides; Liquid kennt ihn in der
      // Section nicht, das Markup des Slides schon.
      this.dots.forEach((dot, i) => {
        const name = this.slidesEls[i]?.getAttribute('aria-label');
        if (name) dot.setAttribute('aria-label', name);
      });

      if (this.slidesEls.length < 2) return;

      this.querySelector('[data-sbm-prev]')?.addEventListener('click', () => {
        this.stop();
        this.go(this.index - 1);
      });
      this.querySelector('[data-sbm-next]')?.addEventListener('click', () => {
        this.stop();
        this.go(this.index + 1);
      });
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.stop();
          this.go(i);
        });
      });

      // Wer im Slide etwas bedient (Menge, Einpacken) oder ihn im Editor
      // bearbeitet, soll nicht weggeblaettert werden.
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('shopify:block:select', (event) => {
        this.stop();
        const slide = event.target.closest?.('[data-sbm-slide]');
        const i = this.slidesEls.indexOf(slide);
        if (i >= 0) this.go(i);
      });

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced || !this.hasAttribute('data-autoplay')) return;
      const seconds = Math.max(4, parseInt(this.dataset.interval, 10) || 8);
      this.timer = setInterval(() => this.go(this.index + 1), seconds * 1000);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    go(next) {
      const count = this.slidesEls.length;
      this.index = ((next % count) + count) % count;
      this.slidesEls.forEach((slide, i) => {
        slide.hidden = i !== this.index;
      });
      this.dots.forEach((dot, i) => {
        if (i === this.index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }
  }

  if (!customElements.get('sbm-content-carousel')) {
    customElements.define('sbm-content-carousel', SbmContentCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbm-cart"] && !Shopify.designMode) return;
  try {
    
  // Warenkorb-Updates über die Cart-Ajax-API + Section-Rendering-API:
  // jede Aktion rendert die komplette Section neu (sections: [id]) und ersetzt
  // sie im DOM. Delegation auf document, damit Listener Re-Renders überleben.
  (() => {
    const getCartRoot = (el) => el.closest('[data-sbm-cart]');

    async function sbmCartRequest(root, url, payload) {
      if (root.classList.contains('is-busy')) return null;
      root.classList.add('is-busy');
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(Object.assign({}, payload, { sections: [root.dataset.sectionId] })),
        });
        const data = await response.json();
        if (!response.ok) {
          if (window.sbmToast) window.sbmToast(data.description || data.message || root.dataset.msgError);
          return null;
        }
        return data;
      } catch (error) {
        if (window.sbmToast) window.sbmToast(root.dataset.msgError);
        return null;
      } finally {
        root.classList.remove('is-busy');
      }
    }

    function sbmCartRender(sectionId, html) {
      const container = document.getElementById('shopify-section-' + sectionId);
      if (!container || !html) {
        window.location.reload();
        return;
      }
      const fresh = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('shopify-section-' + sectionId);
      if (!fresh) {
        window.location.reload();
        return;
      }
      container.innerHTML = fresh.innerHTML;

      // Header-Zähler aktualisieren (sections/sbm-header.liquid)
      const root = container.querySelector('[data-sbm-cart]');
      const badge = document.querySelector('[data-sbm-cart-count]');
      if (root && badge) {
        badge.textContent = root.dataset.cartCount;
        badge.classList.toggle('is-empty', root.dataset.cartCount === '0');
      }
      // Event-Contract: Header-Pop neu auslösen (sections/sbm-header.liquid)
      if (root) {
        document.dispatchEvent(
          new CustomEvent('sbm:cart:count', { detail: { count: parseInt(root.dataset.cartCount, 10) || 0 } })
        );
      }
    }

    async function sbmCartAction(root, url, payload) {
      const data = await sbmCartRequest(root, url, payload);
      if (data) sbmCartRender(root.dataset.sectionId, data.sections[root.dataset.sectionId]);
      return data;
    }

    document.addEventListener('click', (event) => {
      // Menge ändern (0 entfernt die Position, wie im Prototyp)
      const qtyBtn = event.target.closest('[data-sbm-cart-minus], [data-sbm-cart-plus]');
      if (qtyBtn) {
        const root = getCartRoot(qtyBtn);
        if (!root) return;
        const delta = qtyBtn.hasAttribute('data-sbm-cart-minus') ? -1 : 1;
        const quantity = Math.max(0, (parseInt(qtyBtn.dataset.qty, 10) || 0) + delta);
        sbmCartAction(root, root.dataset.urlChange, { line: parseInt(qtyBtn.dataset.line, 10), quantity });
        return;
      }

      // Position entfernen
      const removeBtn = event.target.closest('[data-sbm-cart-remove]');
      if (removeBtn) {
        const root = getCartRoot(removeBtn);
        if (!root) return;
        sbmCartAction(root, root.dataset.urlChange, { line: parseInt(removeBtn.dataset.line, 10), quantity: 0 });
        return;
      }

      // Upsell dazulegen
      const upsellBtn = event.target.closest('[data-sbm-upsell-add]');
      if (upsellBtn) {
        const root = getCartRoot(upsellBtn);
        if (!root) return;
        const message = upsellBtn.dataset.addedMessage;
        sbmCartAction(root, root.dataset.urlAdd, {
          id: parseInt(upsellBtn.dataset.variantId, 10),
          quantity: 1,
        }).then((data) => {
          if (data && window.sbmToast) window.sbmToast(message);
        });
        return;
      }

      // Gutschein entfernen
      const discountRemove = event.target.closest('[data-sbm-discount-remove]');
      if (discountRemove) {
        const root = getCartRoot(discountRemove);
        if (!root) return;
        const remaining = Array.from(root.querySelectorAll('[data-sbm-discount-code]'))
          .map((el) => el.dataset.code)
          .filter((code) => code && code !== discountRemove.dataset.code);
        sbmCartAction(root, root.dataset.urlUpdate, { discount: remaining.join(',') });
      }
    });

    // Karten auf der Warenkorbseite (z. B. „Empfohlene Produkte", #208) legen
    // über snippets/sbm-product-actions in den Warenkorb, an dieser Section
    // vorbei. Weicht die Stückzahl danach vom angezeigten Stand ab, wird die
    // Section neu geholt. Der eigene Re-Render meldet denselben Stand und
    // bleibt dadurch folgenlos.
    document.addEventListener('sbm:cart:count', async (event) => {
      const root = document.querySelector('[data-sbm-cart]');
      if (!root || root.classList.contains('is-busy')) return;
      if (String(event.detail && event.detail.count) === root.dataset.cartCount) return;
      const response = await fetch(window.location.pathname + '?section_id=' + root.dataset.sectionId);
      if (response.ok) sbmCartRender(root.dataset.sectionId, await response.text());
    });

    // Gutschein einlösen (Cart-Ajax-API, discount-Feld — wie Horizon
    // assets/cart-discount.js; ungültige Codes: applicable === false)
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-sbm-discount-form]');
      if (!form) return;
      event.preventDefault();
      const root = getCartRoot(form);
      const input = form.querySelector('[data-sbm-discount-input]');
      const error = root.querySelector('[data-sbm-discount-error]');
      if (!root || !input) return;
      const code = input.value.trim();
      if (!code) return;

      if (error) error.hidden = true;
      input.removeAttribute('aria-invalid');

      const data = await sbmCartRequest(root, root.dataset.urlUpdate, { discount: code });
      if (!data) return;

      const entry = (data.discount_codes || []).find((d) => d.code.toUpperCase() === code.toUpperCase());
      if (!entry || entry.applicable === false) {
        if (error) error.hidden = false;
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }

      sbmCartRender(root.dataset.sectionId, data.sections[root.dataset.sectionId]);
      if (window.sbmToast) {
        window.sbmToast(root.dataset.msgDiscountApplied.replace('[code]', entry.code));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbm-collection"] && !Shopify.designMode) return;
  try {
    
  // Filter-Panel: beide Schalter (Leiste und Panel-Fuss) klappen es auf und
  // zu. Der Zustand haelt die Sitzung ueber, weil jeder Facetten-Klick die
  // Seite neu laedt — siehe Inline-Skript in der Section.
  document.querySelectorAll('[data-sbm-filter-panel]').forEach((panel) => {
    const toggles = Array.from(document.querySelectorAll('[data-sbm-filter-toggle]'));
    if (!toggles.length) return;

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const open = panel.hidden;
        panel.hidden = !open;
        toggles.forEach((t) => {
          if (t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', String(open));
        });
        try {
          sessionStorage.setItem('sbm:collection:filter', open ? '1' : '0');
        } catch (e) {
          // Privates Fenster oder gesperrter Speicher — dann eben ohne Gedaechtnis.
        }
      });
    });
  });

  // Ein offenes Auswahlmenue schliesst, sobald daneben geklickt wird. <details>
  // bringt das nicht mit.
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.sbm-collection__menu[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });

  // Schatten, Seitenkanten und flache Buttons erst, wenn der Block wirklich klebt.
  document.querySelectorAll('[data-sbm-sentinel]').forEach((sentinel) => {
    const sticky = document.querySelector('[data-sbm-sticky]');
    if (!sticky || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(
      (entries) => sticky.classList.toggle('is-stuck', !entries[0].isIntersecting),
      { rootMargin: '-1px 0px 0px 0px', threshold: 0 }
    ).observe(sentinel);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbm-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var loading = null;

    function loadScript(src, id) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = src;
        if (id) script.id = id;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    function loadZammad() {
      if (!loading) {
        var jq = window.jQuery ? Promise.resolve() : loadScript('https://code.jquery.com/jquery-3.6.0.min.js');
        loading = jq.then(function () {
          return loadScript('https://stoertebeker.zammad.com/assets/form/form.js', 'zammad_form_script');
        });
        loading.catch(function () {
          loading = null;
        });
      }
      return loading;
    }

    // Ergänzt Schließen-Knopf, Escape und Dialog-Semantik, nachdem Zammad
    // den Dialog an <body> gehängt hat.
    function enhance(open) {
      var $ = window.jQuery;
      var $open = $(open);
      var $modal = $('.zammad-form-modal').last();
      var $body = $modal.find('.zammad-form-modal-body');
      var titleId = 'sbm-zammad-title';
      var $close = $('<button type="button" class="sbm-footer__zammad-close">&times;</button>').attr('aria-label', open.dataset.closeLabel);

      function close() {
        $modal.remove();
        $(document).off('keydown.sbm-zammad');
        $open.trigger('focus');
      }

      $modal.find('.zammad-form h2').first().attr('id', titleId);
      $body.attr({ role: 'dialog', 'aria-modal': 'true', 'aria-labelledby': titleId }).prepend($close);
      $modal.find('button[type="submit"]').addClass('sbm-button');

      $close.on('click', close);
      $modal.find('.js-zammad-form-modal-backdrop').on('click', close);
      $(document).off('keydown.sbm-zammad').on('keydown.sbm-zammad', function (event) {
        if (event.key === 'Escape') close();
      });

      // Widerruf: Ticket-Titel mit Bestellnummer, siehe Kopfkommentar.
      if (open.dataset.ticketTitle) {
        var $title = $('<input type="hidden" name="title">').val(open.dataset.ticketTitle);
        $modal.find('form').append($title);
        $modal.find('#sbm-withdrawal-order-modal').on('input', function () {
          var order = this.value.trim();
          $title.val(order ? open.dataset.ticketTitle + ' – Bestellung ' + order : open.dataset.ticketTitle);
        });
      }

      $modal.find('.zammad-form-control').first().trigger('focus');
    }

    document.addEventListener('click', function (event) {
      var open = event.target.closest('[data-sbm-zammad-open]');
      if (!open || open.dataset.zammadReady) return;
      // Der Widerruf ist ein Link auf die Richtlinie, der nur greift, wenn
      // Zammad nicht lädt.
      event.preventDefault();

      loadZammad().then(function () {
        var $open = window.jQuery(open);
        var options = {
          modal: true,
          showTitle: true,
          messageTitle: open.dataset.title,
          messageSubmit: open.dataset.submit,
          messageThankYou: open.dataset.thankYou
        };
        if (open.dataset.fields) options.attributes = JSON.parse(open.dataset.fields);
        open.dataset.zammadReady = 'true';
        $open.ZammadForm(options);
        // Zammad hat seinen Klick-Handler zuerst gebunden, dieser läuft
        // danach, wenn der Dialog schon im DOM hängt.
        $open.on('click.sbm-zammad', function () {
          enhance(open);
        });
        $open.trigger('click');
      }).catch(function () {
        if (open.href) window.location.href = open.href;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbm-header"] && !Shopify.designMode) return;
  try {
    
  // Horizon-Layout-Variablen setzen (theme.liquid erwartet header-component, das es hier nicht gibt)
  (function () {
    const header = document.querySelector('.sbm-header');
    const group = document.getElementById('header-group');
    if (!header) return;
    document.body.style.setProperty('--header-height', header.offsetHeight + 'px');
    if (group) document.body.style.setProperty('--header-group-height', group.offsetHeight + 'px');
  })();

  // Dropdown der Desktop-Navigation: Hover und Fokus erledigt CSS, der Klick
  // auf den Pfeil schaltet zusaetzlich eine Klasse. ESC schliesst, ein Klick
  // ausserhalb ebenfalls.
  (function () {
    const items = Array.from(document.querySelectorAll('[data-sbm-dropdown]'));
    if (!items.length) return;

    function close(item) {
      item.classList.remove('is-open');
      const toggle = item.querySelector('[data-sbm-dropdown-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    items.forEach(function (item) {
      const toggle = item.querySelector('[data-sbm-dropdown-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        const open = !item.classList.contains('is-open');
        items.forEach(close);
        if (open) {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') items.forEach(close);
    });

    document.addEventListener('click', function (event) {
      items.forEach(function (item) {
        if (!item.contains(event.target)) close(item);
      });
    });
  })();

  // Burgermenue (AP-06 #14/#54): Panel auf-/zuklappen, Untermenues als zweite
  // Ebene darin. Geschlossen wird ueber den Button selbst, ESC und den Wechsel
  // auf Desktop-Breite.
  (function () {
    const burger = document.querySelector('[data-sbm-burger]');
    const panel = document.querySelector('[data-sbm-menu-panel]');
    if (!burger || !panel) return;

    function setOpen(open) {
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
    }

    burger.addEventListener('click', function () {
      setOpen(burger.getAttribute('aria-expanded') !== 'true');
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (burger.getAttribute('aria-expanded') !== 'true') return;
      setOpen(false);
      burger.focus();
    });

    // Beim Wechsel auf Desktop schliessen, damit der Zustand nicht haengen
    // bleibt, wenn spaeter wieder verkleinert wird.
    const wide = window.matchMedia('(min-width: 901px)');
    wide.addEventListener('change', function (event) {
      if (event.matches) setOpen(false);
    });

    panel.querySelectorAll('[data-sbm-submenu]').forEach(function (toggle) {
      const sub = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!sub) return;
      toggle.addEventListener('click', function () {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        sub.hidden = !open;
      });
    });
  })();

  // Warenkorb-Zähler: auf sbm:cart:count reagieren (Prototyp Z.60, cartPulseKey).
  // Zähler aktualisieren UND die Pop-Animation bei jedem Hinzufügen neu auslösen.
  document.addEventListener('sbm:cart:count', function (event) {
    const count = event.detail && event.detail.count;
    document.querySelectorAll('[data-sbm-cart-count]').forEach(function (el) {
      if (typeof count === 'number') {
        el.textContent = count;
        el.classList.toggle('is-empty', count === 0);
      }
      // Animation neu starten: entfernen, Reflow erzwingen, wieder setzen.
      el.style.animation = 'none';
      void el.offsetWidth;
      el.style.animation = '';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbm-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  // Bühne mit mehreren Slides. Als Custom Element, damit der Theme Editor die
  // Section beliebig oft neu einsetzen kann, ohne dass wir auf
  // shopify:section:load lauschen müssen.
  class SbmHeroCarousel extends HTMLElement {
    connectedCallback() {
      this.slidesEls = Array.from(this.querySelectorAll('[data-sbm-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-sbm-dot]'));
      this.index = 0;

      // Liquid kann den hinteren Slides kein `hidden` mitgeben, weil ein
      // Baustein seine Position nicht kennt. Bis hierher haelt CSS sie
      // zurueck; ab jetzt steuert das Skript.
      this.go(0);
      this.classList.add('sbm-hero-carousel--bereit');

      // Der Punkt traegt den Namen seines Slides. Liquid kann ihn nicht
      // liefern (die Section sieht die Einstellungen ihrer Bloecke nicht),
      // das Markup des Slides dagegen schon.
      this.dots.forEach((dot, i) => {
        const name = this.slidesEls[i]?.getAttribute('aria-label');
        if (name) dot.setAttribute('aria-label', name);
      });

      if (this.slidesEls.length < 2) return;

      this.querySelector('[data-sbm-prev]')?.addEventListener('click', () => {
        this.stop();
        this.go(this.index - 1);
      });
      this.querySelector('[data-sbm-next]')?.addEventListener('click', () => {
        this.stop();
        this.go(this.index + 1);
      });
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.stop();
          this.go(i);
        });
      });

      // Der Händler soll den gerade bearbeiteten Slide sehen, nicht den, auf
      // den der Timer gerade weiterspringt.
      this.addEventListener('focusin', () => this.stop());
      // Greift auch, wenn die Redaktion einen Baustein *im* Slide auswaehlt —
      // dann ist das Ziel des Events der Baustein, nicht der Slide.
      this.addEventListener('shopify:block:select', (event) => {
        this.stop();
        const slide = event.target.closest?.('[data-sbm-slide]');
        const i = this.slidesEls.indexOf(slide);
        if (i >= 0) this.go(i);
      });

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced || !this.hasAttribute('data-autoplay')) return;
      const seconds = Math.max(4, parseInt(this.dataset.interval, 10) || 8);
      this.timer = setInterval(() => this.go(this.index + 1), seconds * 1000);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    go(next) {
      const count = this.slidesEls.length;
      this.index = ((next % count) + count) % count;
      this.slidesEls.forEach((slide, i) => {
        slide.hidden = i !== this.index;
      });
      this.dots.forEach((dot, i) => {
        if (i === this.index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }
  }

  if (!customElements.get('sbm-hero-carousel')) {
    customElements.define('sbm-hero-carousel', SbmHeroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbm-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  // Blaettern des Empfehlungs-Sliders. Gleiche Mechanik wie bei den
  // Kategorie-Kacheln, aber mit eigenen Attributen — sonst wuerden beide
  // Skripte dieselben Elemente doppelt binden.
  //
  // WICHTIG: Die Empfehlungen laden per Fetch nach. Beim Seitenaufbau gibt es
  // nur den aeusseren Container, Track und Tasten kommen erst spaeter. Die
  // Initialisierung haengt deshalb an einem MutationObserver auf dem
  // Container und wird nachgeholt, sobald der Inhalt da ist.
  document.querySelectorAll('.sbm-upsell').forEach((root) => {
    let bound = false;

    function init() {
      const track = root.querySelector('[data-sbm-upsell-track]');
      const nav = root.querySelector('[data-sbm-upsell-nav]');
      const prev = root.querySelector('[data-sbm-upsell-prev]');
      const next = root.querySelector('[data-sbm-upsell-next]');
      if (!track || !nav || !prev || !next) return;

      function step() {
        const card = track.firstElementChild;
        if (!card) return track.clientWidth;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function update() {
        const scrollable = track.scrollWidth - track.clientWidth > 1;
        nav.hidden = !scrollable;
        if (!scrollable) return;
        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
      }

      if (!bound) {
        bound = true;
        prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
      }

      update();
    }

    init();
    new MutationObserver(init).observe(root, { childList: true, subtree: true });
  });

  document.querySelectorAll('[data-sbm-recommendations]').forEach((container) => {
    if (container.querySelector('.sbm-upsell__grid')) return;

    // Review #51: „Ergaenzende Produkte" sind redaktionell gepflegt und koennen
    // leer sein. Dann einmalig auf „Aehnliche Produkte" zurueckfallen, damit der
    // Bereich nicht verschwindet.
    const load = (url, fallbackIntent) =>
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const fresh = html.querySelector('[data-sbm-recommendations]');
          const empty = !fresh || fresh.innerHTML.trim() === '';
          if (empty && fallbackIntent) {
            return load(url.replace(/intent=[^&]*/, 'intent=' + fallbackIntent), '');
          }
          return { html, fresh, empty };
        });

    load(container.dataset.url, container.dataset.fallbackIntent || '')
      .then(({ html, fresh, empty }) => {
        if (!empty) {
          // Karten-CSS mitnehmen: Die Empfehlungen laden per Fetch, daher fehlt
          // das self-contained sbm-product-card-Stylesheet im initialen
          // PDP-Subset. Das mitgelieferte Section-Stylesheet einmalig in <head>
          // übernehmen, sonst rendern die Karten ohne Rahmen/Bildbereich.
          if (!document.querySelector('style[data-sbm-rec-style]')) {
            const sheet = html.querySelector('style[data-section-stylesheet]');
            if (sheet) {
              const clone = document.createElement('style');
              clone.setAttribute('data-sbm-rec-style', '');
              clone.textContent = sheet.textContent;
              document.head.appendChild(clone);
            }
          }
          container.innerHTML = fresh.innerHTML;
        }
      })
      .catch(() => {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbm-product"]) return;
  try {
    
  document.querySelectorAll('.sbm-product').forEach((root) => {
    const main = root.querySelector('.sbm-product__media img');
    const thumbs = Array.from(root.querySelectorAll('[data-sbm-thumb]'));

    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (main) {
          main.src = btn.dataset.src;
          main.removeAttribute('srcset');
          main.alt = btn.dataset.alt || '';
        }
        thumbs.forEach((t) => t.removeAttribute('aria-current'));
        btn.setAttribute('aria-current', 'true');
      });
    });

    // Wischbare Galerie (#133): Punkte folgen dem Wischen, ein Tipp auf einen
    // Punkt blaettert dorthin. Beim Laden steht die Reihe auf dem Bild der
    // gewaehlten Variante.
    const slides = root.querySelector('[data-sbm-slides]');
    const dots = Array.from(root.querySelectorAll('[data-sbm-dot]'));
    if (slides && dots.length) {
      const initial = slides.querySelector('[data-sbm-slide-initial]');
      if (initial) slides.scrollLeft = initial.offsetLeft - slides.offsetLeft;

      const mark = () => {
        const i = Math.round(slides.scrollLeft / (slides.clientWidth || 1));
        dots.forEach((d, n) => {
          if (n === i) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      };
      slides.addEventListener('scroll', mark, { passive: true });

      dots.forEach((dot, n) => {
        dot.addEventListener('click', () => {
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          slides.scrollTo({ left: n * slides.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
        });
      });
    }

  });

  // AJAX-Add-to-Cart NUR für das PDP-Formular: Marker data-sbm-pdp-add sitzt
  // ausschließlich auf dem Submit-Button dieser Section — .sbm-card-Formulare
  // (Produktkarten) binden ihre eigene Logik und bleiben unberührt.
  document.querySelectorAll('[data-sbm-pdp-add]').forEach((button) => {
    const form = button.form;
    if (!form || form.dataset.sbmPdpBound) return;
    form.dataset.sbmPdpBound = 'true';

    const originalLabel = button.textContent;
    let resetTimer;
    let busy = false;

    form.addEventListener('submit', async (event) => {
      if (button.disabled) return;
      event.preventDefault();
      if (busy) return;
      busy = true;

      try {
        const res = await fetch(button.dataset.addUrl || '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!res.ok) throw new Error('add-to-cart failed');

        // (a) Button-Feedback wie im Prototyp: ~1,4s grün "✓ Hinzugefügt"
        clearTimeout(resetTimer);
        button.classList.add('sbm-button--added');
        button.textContent = button.dataset.addedLabel || originalLabel;
        resetTimer = setTimeout(() => {
          button.classList.remove('sbm-button--added');
          button.textContent = originalLabel;
        }, 1400);

        // (b) Toast ("Im Warenkorb: …")
        const qtyInput = form.querySelector('input[name="quantity"]');
        const qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        if (window.sbmToast && button.dataset.toast) {
          window.sbmToast(button.dataset.toast.replace('[qty]', qty));
        }

        // (c) Event-Contract: Zähler aktualisieren + sbm:cart:count feuern
        try {
          const cartRes = await fetch(button.dataset.cartUrl || '/cart.js', {
            headers: { Accept: 'application/json' },
          });
          const cartData = await cartRes.json();
          if (typeof cartData.item_count === 'number') {
            document.querySelectorAll('[data-sbm-cart-count]').forEach((el) => {
              el.textContent = cartData.item_count;
              el.classList.toggle('is-empty', cartData.item_count === 0);
            });
            document.dispatchEvent(
              new CustomEvent('sbm:cart:count', { detail: { count: cartData.item_count } })
            );
          }
        } catch (e) {
          /* Zähler-Update optional — Warenkorb ist serverseitig korrekt */
        }
      } catch (e) {
        // Fallback: normaler Submit, kein stiller Verlust. form.submit()
        // löst kein submit-Event aus — keine Endlosschleife.
        busy = false;
        form.submit();
        return;
      }
      busy = false;
    });
  });

  // Versand-Info: „zzgl. Versand" klappt ein Fenster auf; Klick daneben oder
  // Esc schliesst es (Esc gibt den Fokus an den Ausloeser zurueck).
  document.querySelectorAll('[data-sbm-ship-info]').forEach((wrap) => {
    const trigger = wrap.querySelector('.sbm-ship-info__trigger');
    const panel = wrap.querySelector('.sbm-ship-info__panel');
    if (!trigger || !panel) return;
    const close = () => {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    };
    trigger.addEventListener('click', () => {
      const open = panel.hidden;
      panel.hidden = !open;
      trigger.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', (event) => {
      if (!panel.hidden && !wrap.contains(event.target)) close();
    });
    wrap.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) {
        close();
        trigger.focus();
      }
    });
  });

  // Mengen-Stepper (−/+) liegt global in snippets/sbm-product-actions.liquid
  // (Delegation auf document), damit er auch auf Karten außerhalb der PDP wirkt.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbm-quick-order"] && !Shopify.designMode) return;
  try {
    
  // Schnellbestellung: Mengen sammeln, Summen live rechnen, gebündelt in den
  // Warenkorb legen. Kein Liquid im javascript-Block — Waehrung, Locale, Routen
  // und Toast-Texte kommen als data-Attribute vom Section-Root.
  document.querySelectorAll('[data-sbm-quick-order]').forEach((root) => {
    const rows = Array.from(root.querySelectorAll('[data-sbm-qo-row]'));
    const subtotalEl = root.querySelector('[data-sbm-qo-subtotal]');
    const depositEl = root.querySelector('[data-sbm-qo-deposit]');
    const submitBtn = root.querySelector('[data-sbm-qo-submit]');
    if (!rows.length || !submitBtn) return;

    let formatter;
    try {
      formatter = new Intl.NumberFormat(root.dataset.locale || 'de', {
        style: 'currency',
        currency: root.dataset.currency || 'EUR',
      });
    } catch (e) {
      formatter = new Intl.NumberFormat('de', { style: 'currency', currency: 'EUR' });
    }
    const money = (cents) => formatter.format(cents / 100);

    const qtyOf = (row) => {
      const input = row.querySelector('[data-sbm-qo-qty]');
      if (!input || input.disabled) return 0;
      return Math.max(0, Math.min(99, parseInt(input.value, 10) || 0));
    };

    const update = () => {
      let subtotal = 0;
      let deposit = 0;
      let totalQty = 0;

      rows.forEach((row) => {
        const qty = qtyOf(row);
        const price = parseInt(row.dataset.price, 10) || 0;
        const pfand = parseInt(row.dataset.pfand, 10) || 0;
        const sumEl = row.querySelector('[data-sbm-qo-sum]');

        row.classList.toggle('is-filled', qty > 0);
        if (sumEl) sumEl.textContent = qty > 0 ? money(price * qty) : '—';

        subtotal += price * qty;
        deposit += pfand * qty;
        totalQty += qty;
      });

      if (subtotalEl) subtotalEl.textContent = money(subtotal);
      if (depositEl) depositEl.textContent = money(deposit);
      submitBtn.disabled = totalQty === 0;
    };

    rows.forEach((row) => {
      const input = row.querySelector('[data-sbm-qo-qty]');
      if (!input) return;
      input.addEventListener('input', update);
      input.addEventListener('change', () => {
        input.value = qtyOf(row);
        update();
      });
    });

    submitBtn.addEventListener('click', async () => {
      const items = rows
        .map((row) => ({ id: parseInt(row.dataset.variantId, 10), quantity: qtyOf(row) }))
        .filter((item) => item.id && item.quantity > 0);
      if (!items.length) return;

      submitBtn.disabled = true;
      try {
        const res = await fetch(root.dataset.addUrl || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) throw new Error('add-to-cart failed');

        // Eingaben zurücksetzen (Prototyp: qo = {}) und Summen neu rechnen
        rows.forEach((row) => {
          const input = row.querySelector('[data-sbm-qo-qty]');
          if (input && !input.disabled) input.value = 0;
        });

        const count = items.reduce((acc, item) => acc + item.quantity, 0);
        if (window.sbmToast) {
          window.sbmToast((root.dataset.toastAdded || '').replace('[count]', count));
        }

        // Warenkorb-Zähler im Header aktualisieren (GET /cart.js liefert
        // item_count); schlägt das fehl, bleibt der Warenkorb serverseitig
        // trotzdem korrekt — deshalb kein Reload nötig.
        try {
          const cartRes = await fetch(root.dataset.cartUrl || '/cart.js', {
            headers: { Accept: 'application/json' },
          });
          const cartData = await cartRes.json();
          if (typeof cartData.item_count === 'number') {
            document.querySelectorAll('[data-sbm-cart-count]').forEach(function (countEl) {
              countEl.textContent = cartData.item_count;
              countEl.classList.toggle('is-empty', cartData.item_count === 0);
            });
            // Event-Contract: Header-Pop neu auslösen (sections/sbm-header.liquid)
            document.dispatchEvent(
              new CustomEvent('sbm:cart:count', { detail: { count: cartData.item_count } })
            );
          }
        } catch (e) {
          /* Zähler-Update optional */
        }
      } catch (e) {
        if (window.sbmToast) window.sbmToast(root.dataset.toastError || '');
      }
      update();
    });

    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbm-vk-product"]) return;
  try {
    
  document.querySelectorAll('.sbm-vk-product').forEach((root) => {
    const main = root.querySelector('.sbm-vk-product__media img');
    const thumbs = Array.from(root.querySelectorAll('[data-sbm-thumb]'));
    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (main) {
          main.src = btn.dataset.src;
          main.removeAttribute('srcset');
          main.alt = btn.dataset.alt || '';
        }
        thumbs.forEach((t) => t.removeAttribute('aria-current'));
        btn.setAttribute('aria-current', 'true');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
